var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.503,
    height: 34.909,
    viewBox: "0 0 30.503 34.909",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1552",
    "data-name": "Group 1552",
    transform: "translate(-1121.997 -304.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1553",
    "data-name": "Group 1553",
    transform: "matrix(0.799, 0.602, -0.602, 0.799, 1143.578, 306.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7197",
    "data-name": "Path 7197",
    d: "M-.318,25.26l4.366,7.78,4.713-7.9S9.1,1.823,9.066,1,8.623-.059,7.718-.089,2.256.039,1.236,0-.017.71-.018,1.448-.318,25.26-.318,25.26Z",
    transform: "translate(-0.053 0)",
    fill: "none",
    stroke: "#053f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63793",
    "data-name": "Line 63793",
    x2: 9.147,
    transform: "translate(-0.458 25.948)",
    fill: "none",
    stroke: "#053f7f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63794",
    "data-name": "Line 63794",
    x2: 9.147,
    transform: "translate(-0.458 5.147)",
    fill: "none",
    stroke: "#053f7f",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_63795",
    "data-name": "Line 63795",
    x2: 27,
    transform: "translate(1124.5 338.644)",
    fill: "none",
    stroke: "#053f7f",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8afdedab947595db9862d3a2397b4fdc.svg";
export { ForwardRef as ReactComponent };